<div class="tutorial-overlay" *ngIf="isVisible && config">
  <div class="tutorial-modal">

    <div class="tutorial-content" *ngIf="currentStep">
      <!-- Step Title and Description -->
      <div class="step-header">
        <h2 class="step-title">{{ currentStep.title }}</h2>
      </div>

       <!-- GIF Section -->
       <div class="gif-section">
         <div class="gif-container">
            <img 
              #gifElement
              [src]="currentStep.gifSrc" 
              [alt]="currentStep.title + ' tutorial GIF'"
              class="tutorial-gif"
              [class.playing]="isGifPlaying"
              [class.completed]="isGifCompleted"
              (load)="onGifLoaded()"
              (error)="onGifError($event)">
         </div>
       </div>
       <div class="step-description-container">
           <p class="step-description">{{ currentStep.description }}</p>
       </div>
       <!-- Action Button -->
       <div class="tutorial-actions">
         <button 
           class="continue-btn"
           [class.primary]="currentStep.isLastStep"
           [class.secondary]="!currentStep.isLastStep"
           (click)="onContinue()"
           [disabled]="isGifPlaying">
           {{ currentStep.buttonText }}
         </button>
       </div>
    </div>
  </div>
</div>
